import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import SectionSubHeader from "../sectionSubHeader";
import SectionHeader from "../sectionHeader";
import CustomButton from "../CustomButton";
import { Link } from "react-router-dom";
import { BsArrowRight } from "react-icons/bs";

const UnlockPotential = () => {
  return (
    <div className="section-bg unlock-potential">
      <Container className="" >
      <SectionHeader mainText1="UNLOCK YOUR POTENTIAL"  />
        <Row>
        
          <Col lg={4}>
           
            <SectionSubHeader headerText="Discover an experience worthy of your talents" />
          </Col>
          <Col lg={8}> 
          <Row>
            <Col lg={4} md={6}>
               <img src="images/make-impact.svg" alt="Make an impact" />
               <p><span>Make an impact.</span> Develop solutions that have real significance to your world.</p>
            </Col>
            <Col lg={4} md={6}>
               <img src="images/work-best.svg" alt="Work with the best" />
               <p><span>Work with the best.</span> Enjoy free-flowing collaboration on extraordinary teams.</p>
            </Col>
            <Col lg={4} md={6}>
               <img src="images/reach-potential.svg" alt="Reach your potential" />
               <p><span>Reach your potential.</span> Expand your skillset and elevate your career.</p>
            </Col>
          </Row>
          
          </Col>
        </Row>
      </Container>
       
    </div>
  );
};

export default UnlockPotential;
